// extracted by mini-css-extract-plugin
module.exports = {"main-layout":"main-layout_main-layout__EJa_w","main-content":"main-layout_main-content__Oamcm"};